import { motion } from "framer-motion";

// Central hub visualization — connection lines from 5 spokes flowing into a
// central digital case file at the middle.
export default function CentralHubViz() {
  return (
    <div className="relative w-[70%] md:w-full aspect-square max-w-[520px] mx-auto">
      {/* Background halo */}
      <div
        aria-hidden
        className="absolute inset-6 rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(0,250,248,0.14), transparent 60%)",
          filter: "blur(24px)",
        }}
      />

      <svg viewBox="0 0 600 600" className="relative w-full h-full">
        <defs>
          <radialGradient id="hubCore" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#00FAF8" stopOpacity="0.35" />
            <stop offset="60%" stopColor="#0F172A" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="lineGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#00FAF8" stopOpacity="0" />
            <stop offset="1" stopColor="#00FAF8" stopOpacity="0.9" />
          </linearGradient>
        </defs>

        {/* Concentric rings */}
        <circle cx="300" cy="300" r="260" fill="none" stroke="rgba(255,255,255,0.05)" />
        <circle cx="300" cy="300" r="200" fill="none" stroke="rgba(255,255,255,0.06)" />
        <circle cx="300" cy="300" r="140" fill="none" stroke="rgba(255,255,255,0.07)" />

        {/* Halo */}
        <circle cx="300" cy="300" r="140" fill="url(#hubCore)" />

        {/* Connection lines (flowing) */}
        {SPOKES.map((s, i) => (
          <g key={i}>
            <line
              x1={s.x}
              y1={s.y}
              x2="300"
              y2="300"
              stroke="rgba(0,250,248,0.15)"
              strokeWidth="1"
            />
            <line
              x1={s.x}
              y1={s.y}
              x2="300"
              y2="300"
              stroke="#00FAF8"
              strokeWidth="1.6"
              className="bp-flow-line"
              opacity="0.9"
            />
          </g>
        ))}

        {/* Center: digital case file (folder) */}
        <g transform="translate(238 238)">
          <rect
            x="0"
            y="0"
            width="124"
            height="124"
            rx="20"
            fill="#0F172A"
            stroke="rgba(0,250,248,0.5)"
            strokeWidth="1.2"
          />
          <rect
            x="0"
            y="0"
            width="124"
            height="24"
            rx="20"
            fill="rgba(0,250,248,0.12)"
          />
          <rect x="14" y="42" width="70" height="4" rx="2" fill="rgba(255,255,255,0.4)" />
          <rect x="14" y="54" width="96" height="4" rx="2" fill="rgba(255,255,255,0.15)" />
          <rect x="14" y="66" width="84" height="4" rx="2" fill="rgba(255,255,255,0.15)" />
          <rect x="14" y="82" width="40" height="16" rx="4" fill="rgba(0,250,248,0.2)" />
          <rect x="60" y="82" width="30" height="16" rx="4" fill="rgba(255,255,255,0.08)" />
        </g>
      </svg>

      {/* Spoke chips (positioned) */}
      {SPOKES.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, scale: 0.85 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ delay: 0.15 * i, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/10 bg-[#0F172A]/90 backdrop-blur px-2 py-1 md:px-3 md:py-1.5 shadow-[0_10px_40px_-10px_rgba(0,250,248,0.25)]"
          style={{
            left: `${(s.x / 600) * 100}%`,
            top: `${(s.y / 600) * 100}%`,
          }}
        >
          <div className="flex items-center gap-2">
            <span className="cyan-dot" />
            <span className="text-[10px] md:text-[11px] font-mono-bp text-white/85 whitespace-nowrap">
              {s.label}
            </span>
          </div>
        </motion.div>
      ))}
    </div>
  );
}

const SPOKES = [
  { label: "Termine", x: 300, y: 60 },
  { label: "Kommunikation", x: 520, y: 200 },
  { label: "Dokumente", x: 480, y: 460 },
  { label: "Ereignisse", x: 120, y: 460 },
  { label: "Umgänge", x: 80, y: 200 },
];
